module.exports = __webpack_public_path__ + "img/fu_excel.png";